import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-list-grid-trigger',
  templateUrl: './list-grid-trigger.component.html',
  styleUrls: ['./list-grid-trigger.component.scss']
})
export class ListGridTriggerComponent implements OnInit {

  static CLASS_BODY_RESULT_AS_LIST: string = 'results-as-list';

  constructor() {
  }

  public isGridViewActivated: boolean = true;

  ngOnInit() {
    const getViewStatus = localStorage.getItem(ListGridTriggerComponent.CLASS_BODY_RESULT_AS_LIST);

    if (getViewStatus === 'true') {
      this.isGridViewActivated = !this.isGridViewActivated;
      document.getElementsByTagName('body')[0].classList.add(ListGridTriggerComponent.CLASS_BODY_RESULT_AS_LIST);
    }
  }

  public toggleView() {
    this.isGridViewActivated = !this.isGridViewActivated;

    if (!this.isGridViewActivated) {
      document.getElementsByTagName('body')[0].classList.add(ListGridTriggerComponent.CLASS_BODY_RESULT_AS_LIST);
      localStorage.setItem(ListGridTriggerComponent.CLASS_BODY_RESULT_AS_LIST, 'true');
    } else {
      document.getElementsByTagName('body')[0].classList.remove(ListGridTriggerComponent.CLASS_BODY_RESULT_AS_LIST);
      localStorage.setItem(ListGridTriggerComponent.CLASS_BODY_RESULT_AS_LIST, 'false');
    }

  }
}
